import { createReducer, INITIAL_STATE } from '@shared/redux';

export const UPDATE_USER_SETTINGS_SUBMITTED = '@settings/UPDATE_USER_SETTINGS_SUBMITTED';
export const UPDATE_USER_SETTINGS_ACCEPTED = '@settings/UPDATE_USER_SETTINGS_ACCEPTED';
export const UPDATE_USER_SETTINGS_REJECTED = '@settings/UPDATE_USER_SETTINGS_REJECTED';
export const USER_SETTINGS_MODAL_TOGGLED = '@settings/USER_SETTINGS_MODAL_TOGGLED';

export const getIsModalOpen = state => state.settings.updateUserSettings.isModalOpen;

export const toggleModalUserSettings = isModalOpen => ({
    type: USER_SETTINGS_MODAL_TOGGLED,
    payload: { isModalOpen },
});

export const submitUpdateUserSettings = userProfile => ({
    type: UPDATE_USER_SETTINGS_SUBMITTED,
    payload: userProfile,
});

export const acceptUpdateUserSettings = () => ({
    type: UPDATE_USER_SETTINGS_ACCEPTED,
    payload: {},
});

export const rejectUpdateUserSettings = ({ error }) => ({
    type: UPDATE_USER_SETTINGS_REJECTED,
    payload: { error },
});

export const updateUserSettingsReducer = createReducer({
    [INITIAL_STATE]: {
        isModalOpen: false,
        error: null,
        loading: false,
    },

    [USER_SETTINGS_MODAL_TOGGLED]: (state, action) => ({
        ...state,
        isModalOpen: action.payload.isModalOpen,
    }),

    [UPDATE_USER_SETTINGS_SUBMITTED]: state => ({
        ...state,
        loading: true,
    }),

    [UPDATE_USER_SETTINGS_ACCEPTED]: state => ({
        ...state,
        loading: false,
    }),

    [UPDATE_USER_SETTINGS_REJECTED]: (state, action) => ({
        ...state,
        loading: false,
        error: action.payload.error,
    }),
});
